require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./centres-mildura-central-early-learning-centre.json") })
        }
      }, "path---centres-mildura-central-early-learning-centre");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---centres-mildura-central-early-learning-centre!./.cache/json/centres-mildura-central-early-learning-centre.json
// module id = 1228
// module chunks = 231608221292675